import React from 'react'

const React_Coding_Practice_18 = () => {
  return (
    <div>
      <h1>Coding Pratice 18</h1>
    </div>
  )
}

export default React_Coding_Practice_18
